import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  colors: {
    accentColor: string
    colorBackground: string
    textBody: string
    textAccentColor: string
    colorBackgroundSecundary: string
    accentColorBackground: string
    cardAccentColor: string
  }
  matchesMobile: boolean
  matches: boolean
}

const stylesAppsHome = makeStyles<Theme, StyleProps>((theme) => ({
  main: (props) => ({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: '#EDEDED',
    alignItems: 'center',
    padding: props.matchesMobile ? '50px 5px 40px' : '80px 5px 108px',
    overflowX: 'hidden',
  }),
  card: (props) => ({
    position: 'relative',
    marginLeft: 5,
    marginRight: 5,
    marginTop: 10,
    height: props.matchesMobile ? 144 : 180,
    maxWidth: props.matchesMobile ? 144 : 180,
    width: '100%',
    borderRadius: '50%',
    color: props.colors.accentColor,
    fontSize: theme.typography.pxToRem(18),
    '&:hover': {
      boxShadow: '0px 12px 42px -4px rgba(24, 39, 75, 0.12)',
      backgroundColor: props.colors.colorBackground,
    },
  }),
  textTitle: (props) => ({
    fontSize: props.matchesMobile ? 20 : 24,
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    fontWeight: 700,
    color: props.colors.accentColor,
    display: 'flex',
    alignItems: 'center',
    flexDirection: props.matches ? 'column' : 'row',
    gap: 16,
  }),
  textSubTitle: (props) => ({
    position: 'relative',
    fontFamily: 'Roboto',
    padding: '10px 0px',
    color: props.colors.textBody,
    letterSpacing: '0.1px',
    lineHeight: '24px',
    fontWeight: 400,
    fontSize: 18,
    opacity: 0.5,
  }),
  button: (props) => ({
    border: `1px solid ${props.colors.textAccentColor}`,
    padding: '5px 10px',
    marginBottom: 10,
    borderRadius: 5,
    color: props.colors.textAccentColor,
    '&:hover': {
      background: props.colors.colorBackgroundSecundary,
      color: props.colors.accentColor,
    },
  }),
  iconNavigate: (props) => ({
    color: props.colors.accentColor,
    border: `1px solid ${props.colors.accentColor}`,
    '&:hover': {
      color: props.colors.accentColor,
      background: props.colors.textBody,
      transition: 'all 0.2s ease',
    },
  }),
  IconNavite: (props) => ({
    color: '#fff',
    width: 32,
    height: 32,
    background: props.colors.accentColorBackground,
    padding: 0,
    '&:hover': {
      backgroundColor: props.colors.cardAccentColor,
      color: '#fff',
    },
  }),
  icon: {
    width: '100%',
    height: '100%',
  },
  slider: {
    display: 'flex !important',
    alignItems: 'center',
    '& .slick-list': {
      margin: 0,
    },
    '& .slick-slide': {
      padding: 0,
    },
  },
  boxCover: (props) => ({
    background: props.colors.cardAccentColor,
    backgroundSize: 'cover',
    '&:hover': {
      color: '#fff',
    },
  }),
}))

export default stylesAppsHome
